import React from "react"
import Layout from "../../ui/Layout"
import NavMain from "../../app/NavMain"
import { Helmet } from "react-helmet-async"
import ScrollablePage from "../../ui/ScrollablePage"
import { Action, Actions, Header, Overview } from "../../ui/PageHeader"
import styled from "styled-components"
import PropTypes from "prop-types"
import Button from "../../ui/Button"
import { faDownload, faEnvelope } from "@fortawesome/free-solid-svg-icons"
import { API_BASE_URL } from "../../app/config"
import { useSelector } from "react-redux"
import { selectAuth } from "../iam/slice"

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding-top: 1rem;
`

Container.propTypes = { children: PropTypes.node }

/**
 * Logged-in user profile page
 *
 * @returns {JSX.Element}
 * @constructor
 */
const Support = () => {
  const { token } = useSelector(selectAuth)

  // Function to construct the email address (minor obfuscation)
  const getEmailAddress = () => {
    const user = "astrosite"
    const domain = "westernsydney.edu.au"
    return `${user}@${domain}`
  }

  function downloadUserManaul(token) {
    // Create a temporary link element
    const link = document.createElement("a")
    link.href = `${API_BASE_URL}/api/support/user-manual${
      token ? "?token=" + encodeURIComponent(token) : ""
    }`
    link.target = "_blank" // Open the download in a new tab

    // Trigger the download
    link.click()
  }

  return (
    <Layout>
      <NavMain />
      <Helmet>
        <title>Support - Astrosite</title>
      </Helmet>
      <ScrollablePage>
        <Header>
          <Overview>
            <h1>Support</h1>
          </Overview>
          <Actions>
            <>
              <Action>
                <Button
                  onClick={() => downloadUserManaul(token)}
                  icon={faDownload}
                >
                  User Manual
                </Button>
              </Action>
            </>
            <>
              <Action>
                <a href={`mailto:${getEmailAddress()}`}>
                  <Button onClick={() => {}} icon={faEnvelope}>
                    Email support
                  </Button>
                </a>
              </Action>
            </>
          </Actions>
        </Header>
        <Container>
          <div>
            <p>
              For operating instructions we provide a{" "}
              <a href="" onClick={() => downloadUserManaul(token)}>
                user manual{" "}
              </a>
              .
            </p>
            <p>
              If you&apos;re experiencing any issues or have additional
              questions, please don&apos;t hesitate to{" "}
              <a href={`mailto:${getEmailAddress()}`}>contact us</a>.
            </p>
          </div>
        </Container>
      </ScrollablePage>
    </Layout>
  )
}

export default Support
